<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";
    import { onMount } from "svelte";

    import { masonryControllerToken } from "./context_tokens";
    import MasonryController from "./MasonryController";

    export let controller: MasonryController;
    setTypedContext(masonryControllerToken, controller);
    onMount(() => {
        controller.update();
    });
</script>

<svelte:window on:resize={() => controller.update()} />

<div class="gw-masonry">
    <ul class="gw-masonry__grid gw-list-reset-default-styles">
        <slot />
    </ul>
</div>

<style>
    .gw-masonry__grid {
        --gw-masonry-columns-count: auto-fill;
        --gw-masonry-columns-width: minmax(250px, 1fr);
        display: grid;
        grid-template-columns: repeat(
            var(--gw-masonry-columns-count),
            var(--gw-masonry-columns-width)
        );
        grid-auto-rows: 20px;
        gap: 10px;
    }
</style>
